import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";

export default function ProductsApiSPlugingsAndApps() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/api.png"
          alt="APIs, Plugins, and Apps"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">
          API&apos;s Plugins and Apps
        </div>
      </div>

      <div>
        <p className="fs-5 mt-3">
          A no-code philosophy sits at the core of Boomerang. It defines how the
          platform is built and how our customers interact with it, removing the
          dependency on development resources while still enabling complex,
          business-critical workflows.
        </p>
        <p className="fs-5 ">
          Boomerang allows organisations to design, connect, and run
          sophisticated processes in a codeless environment without compromising
          control or capability. This extends across APIs, plugins, SDKs and
          applications, giving customers the flexibility to integrate with
          existing systems and external services as required.
        </p>
        <p className="fs-5 ">
          Through boomLogic, users are guided through a structured, step-by-step
          approach to building and managing workflows. This includes connecting
          to third-party platforms, ingesting data, executing processes, and
          returning outcomes—without the cost, time, or risk typically
          associated with custom development.
        </p>
        <p className="fs-5 ">
          There is no requirement for developer-level expertise. Where support
          is needed, it is available, but the platform is designed so that
          operational teams can own and evolve their processes directly.
        </p>
        <p className="fs-5 ">
          Boomerang supports integration with a wide range of systems,
          including:
        </p>
        <p>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Microsoft Power Apps</span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Microsoft plugins</span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">APIs</span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">SDKs</span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Active Directory</span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Nylas</span>
            </span>
          </div>
        </p>
        <p className="fs-5 ">
          This enables organisations to run complex processes that would
          otherwise be difficult, costly, or high-risk to build into legacy
          systems. Data can be pulled from third-party applications, processed
          within Boomerang, and returned with updated outcomes, creating a
          seamless flow across systems.
        </p>
        <p className="fs-5 ">
          The result is simple: greater control over processes, reduced
          development overhead, and access to detailed operational insight
          without the usual constraints of cost or delivery risk.
        </p>
        <p className="fs-5 ">
          APIs, plugins, and applications within Boomerang can also be combined
          with:
        </p>
        <p>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/professionalBuilder"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Professional Builder</span>
            </a>
          </div>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/eventsAndAlerting"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Events</span>
            </a>
          </div>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/monitoringAndAlerting"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Monitoring</span>
            </a>
          </div>
        </p>
      </div>

      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
